type AllowedComponent = {
  path: string;
  title: string;
};

type AEMReactMapping = Record<string, unknown>;

const getResponsiveGridBasePath = (
  model?: Record<string, unknown>,
  subPath = 'jcr:content/root/responsivegrid'
): string | undefined => {
  const modelPath = (model?.['cqPath'] as string) || (model?.[':path'] as string) || (model?.['path'] as string);
  if (!modelPath) return undefined;
  return `${modelPath}/${subPath}`;
};

/**
 * Generates allowed components list for non-author mode
 * @param model - AEM page model
 * @param AEM_REACT_MAPPING - Component path to React component mapping
 * @param AEM_REACT_TITLE_MAPPING - Optional component path to display title mapping
 * @returns Array of allowed components with paths and titles
 */
export const getAllowedComponentsForNonAuthorMode = (
  model: Record<string, unknown> | undefined,
  AEM_REACT_MAPPING: AEMReactMapping,
  AEM_REACT_TITLE_MAPPING?: Record<string, string>
): Array<AllowedComponent> => {
  const basePath = getResponsiveGridBasePath(model);

  if (!basePath) {
    return [];
  }

  return Object.keys(AEM_REACT_MAPPING).map(componentPath => {
    // Use custom title from mapping, or fallback to last segment of path or component path or unknown component which means title is missing from AEM_REACT_TITLE_MAPPING
    const title =
      AEM_REACT_TITLE_MAPPING?.[componentPath] ||
      componentPath.split('/').pop() ||
      componentPath ||
      'Unknown Component';

    return {
      path: `${basePath}/${componentPath}`,
      title,
    };
  });
};
